// extracted by mini-css-extract-plugin
module.exports = {"content":"PricingGraph_content__G_jOc","description":"PricingGraph_description__FrxFQ","caption":"PricingGraph_caption__lJXQC","subtitle":"PricingGraph_subtitle__gkNyR"};